<template>
	<div class="main-container">
		<div style=" box-shadow: 0px 0px 14px 4px rgba(0, 0, 0, 0.11); z-index:999;transform:translateZ(1px);" >
		<div class="wp-nav" >

			<!-- <div class="logo phonecss" v-if="user">
				<a href="https://classover.com/">
					<img src="../assets/img/logo.png" alt="logo" title="logo" />
				</a>
			</div> -->
			<div class="logo  " >
				<a :href="lang=='en'?'https://classover.com/en/':'https://classover.com/cn/'">
					<img src="../assets/img/logo.png" alt="logo" title="logo" />
				</a>
			</div>
			<ul class="nav-list" >
				<li @mouseenter="onMouseOver" @click="lang=='en'? toUrl('https://classover.com/en/our-courses-new/'): toUrl('https://classover.com/cn/ourcourse-cn/')">
				 {{ $t('Subjects')}}
				<i class="el-icon-arrow-down"></i>
					<div  @mouseleave="onMouseOut" class="nav-header" v-if="seen">
						<div>
							<span @click="lang=='en'?toUrl('https://classover.com/en/our-courses-new/ '): toUrl(' https://classover.com/cn/ourcourse-cn/')"> {{$t('Afterschool')}} </span>
							<span @click="lang=='en'? toUrl('https://classover.com/en/tutoring-courses/'): toUrl(' https://classover.com/cn/tutoring-course/')" > {{$t('Tutoring')}} </span>
						</div>
					</div>
				</li>
				<li @click="lang=='en'?toUrl('https://classover.com/en/teachers-new/'): toUrl('https://classover.com/cn/teacher-cn/')"> {{$t('Teachers')}} </li>
				<li @click="lang=='en'?toUrl('https://app.classover.com/parent/#/schedules_pc'): toUrl('https://app.classover.com/parent/#/schedules_pc')">{{$t('Schedule')}} </li>
				<li><router-link to="/">
				{{ $t('Pricing')}}
				</router-link></li>
				<li @click="lang=='en'?toUrl('https://classover.com/en/download/'): toUrl('https://classover.com/cn/download-cn/')"> {{$t('Download')}} </li>
				<li @click="langChange" class="langcss">{{lang=='en'?'':'English Site' }} </li>
			</ul>

			<div class="tool-btn">
				<div v-if="user" class="login-register-two">
					<el-dropdown trigger="click" placement="bottom" @command="handleCommand" >
					<span class="el-dropdown-link">
					<span class="one"><img src="../assets/img/renxiang.png" alt=""></span>
					<span class="two">
						{{ `+${user.user_info.country_code} ${user.user_info.mobile}` }}
					</span>
					</span>
					<el-dropdown-menu slot="dropdown" class="menucss" >
						<el-dropdown-item  command="tourl" > <img src="../assets/img/Group.png" alt=""> User Portal</el-dropdown-item>
						<el-dropdown-item command="logout"  @click="logout"  > <img src="../assets/img/Logoutto.png" alt=""> Logout</el-dropdown-item>
					</el-dropdown-menu>
					</el-dropdown>
				</div>
				<!-- <div v-if="user" class="login-register">
					<span  class="phonecss" @click="logout"> {{ `(+${user.user_info.country_code} ${user.user_info.mobile}) ${$t('Logout')}` }} </span>
					<router-link v-else-if="!user" to="/login" class="login-link" @click.native="gotologin">
					<span>
						{{ $t('Login/Register') }}
					</span>
					</router-link>
				</div> -->
				<div class="contenent">
					<div class=" photopeople" v-if="!user&&loginurl">
						<router-link  to="/login" class="login-link" >
						<img src="../assets/img/Group.png" alt="" >
						</router-link>
					</div>
					<div class="nav-btn background free-trial" >
						<router-link to="/onlineFreeClass?utm_id=17">
							{{ $t('Get FREE Trial') }}
						</router-link>
					</div>
					<!-- <div class="change_lang">
						<img src="../assets/img/cn.png" alt="" @click="langChange('zh_CN') ">
							<img src="../assets/img/us.png" alt="" @click="langChange('en') " >
					</div> -->

					<div class="mobile-menu  mobile-menu-dis hamburger"  >
						<img :src="ulshow?showurl:noshowurl" alt="" @click="toshowul">
					</div>

					</div>

				<!-- <el-dropdown class="lang" trigger="click" @command="langChange">
					<div class="nav-btn">
						<img v-if="lang === 'en'" src="../assets/img/lang-en.png" alt="lang-en" />
						<img v-else src="../assets/img/lang-cn.png" alt="lang-cn" />
						<span class="lang-text">{{ langText }}</span>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="zh_CN">简体中文</el-dropdown-item>
						<el-dropdown-item command="en">English</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown> -->


			</div>
			<ul class=" mobile-menu-nav" v-if="ulshow"  >
				<li :class="ulseen?'lisee':'' " >
				<span @click="lang=='en'? toUrl('https://classover.com/en/our-courses-new/'): toUrl('https://classover.com/cn/ourcourse-cn/')"> {{ $t('Subjects')}}  </span>
				<div style="width:80%;text-align:right;" @click="openover">
				<i class="el-icon-arrow-down" ></i>
				</div>

					<div  class="ul-header" v-if="ulseen">
						<div>
							<span @click="lang=='en'?toUrl('https://classover.com/en/our-courses-new/ '): toUrl(' https://classover.com/cn/ourcourse-cn/')"> {{$t('Afterschool')}} </span>
							<span @click="lang=='en'? toUrl('https://classover.com/en/tutoring-courses/'): toUrl(' https://classover.com/cn/tutoring-course/')" > {{$t('Tutoring')}} </span>
						</div>
					</div>
				</li>
				<li @click="lang=='en'?toUrl('https://classover.com/en/teachers-new/'): toUrl('https://classover.com/cn/teacher-cn/')"> {{$t('Teachers')}} </li>
				<li @click="lang=='en'?toUrl('https://app.classover.com/parent/#/schedules_pc'): toUrl('https://app.classover.com/parent/#/schedules_pc')">{{$t('Schedule')}} </li>
				<li><router-link to="/">
				{{ $t('Pricing')}}
				</router-link></li>
				<li @click="lang=='en'?toUrl('https://classover.com/en/download/'): toUrl('https://classover.com/cn/download-cn/')"> {{$t('Download')}} </li>
<!--				<li @click="langChange" class="langcss">{{lang=='en'?'中文官网':'English Site' }} </li>-->
				<li @click="langChange" class="langcss" v-if="lang !='en'">English Site</li>
				<li class="nav-li">
					<div class="nav-btn background" >
						<router-link to="/freeTrial?utm_id=9" @click.native="changelink()">
							{{ $t('Get FREE Trial') }}
						</router-link>
					</div>
				</li>
			</ul>
		</div></div>
		<router-view />
	</div>
</template>

<script>
	import { getIntercomUser} from '../api';
	import { setStore, keys, getStore, clearStore } from '../store';
	import { EventBus ,getTimeZoneCity} from '../utils';
	import i18n from '../locales/i18n';

	export default {
		data() {
			return {
				user: null,
				lang: '',
				// logingo:true
				seen:false,
				ulseen:false,
				ulshow:false,
				showurl:require("../assets/img/Vector.png"),
				noshowurl:require("../assets/img/hamburger.png"),
				loginurl:true
			};
		},
		beforeRouteUpdate(to, from, next){
        //这个组件是被复用的时候调用，比如带有动态参数的路由跳转：/foo/11 跳转到 /foo/12
        console.log(this) // 可以访问this
		console.log(to.fullPath)
		if(to.fullPath.indexOf('login')>-1){
			this.loginurl=false
		}
		else{
			this.loginurl=true
		}
        next()
    },
		created(){
      console.log(222,this.$intercom)
			this.id=this.$route.params.id
            // this.$router.push({ params: {id:''} });
		},
		mounted() {
			if(window.location.href.indexOf('login')>-1){
				this.loginurl=false
				console.log(this.loginurl)
			}else{
				this.loginurl=true
				console.log(this.loginurl)
			}
			this.user = getStore(keys.user);
			EventBus.$on('login', () => {
				this.user = getStore(keys.user);
			});
			console.log(this.user);
			this.lang = i18n.locale;
						if( this.id){
					if(this.id=='en'){
						i18n.locale=this.lang='en'
						setStore('lang',i18n.locale)
					}
					else if(this.id=='cn'){
						i18n.locale=this.lang='zh_CN'
						setStore('lang',i18n.locale)
					}
			}
			if(!getStore(keys.IntercomUser)){
				return;
			}
			this.$intercom.boot({
				user_id: getStore(keys.IntercomUser).userId,
				phone: getStore(keys.IntercomUser).phone,
				email: getStore(keys.IntercomUser).email,
				name: getStore(keys.IntercomUser).name,
				'Kid Name': getStore(keys.IntercomUser).kid_name,
				'Timezone': getStore(keys.IntercomUser).Timezone,
				'Paid user': getStore(keys.IntercomUser).paid_user,
				'Credit balance': getStore(keys.IntercomUser).credit_balance
				// Phone_Number: getStore(keys.IntercomUser).phone
			})
			this.$intercom._init()
			this.$intercom.update({
				user_id: getStore(keys.IntercomUser).userId,
				phone: getStore(keys.IntercomUser).phone,
				email: getStore(keys.IntercomUser).email,
				name: getStore(keys.IntercomUser).name,
				'Kid Name': getStore(keys.IntercomUser).kid_name,
				'Timezone': getStore(keys.IntercomUser).Timezone,
				'Paid user': getStore(keys.IntercomUser).paid_user,
				'Credit balance': getStore(keys.IntercomUser).credit_balance
				// Phone_Number: getStore(keys.IntercomUser).phone
			})


			console.log(this.$intercom.visible)
		},
		watch: {
			'$intercom.visible': function (val) {
				if (val == true) {
				this.updateIntercom()
				}
			},
			email (email) {
				this.$intercom.update({email})
			}
		},
		computed: {
			langText() {
				return this.lang === 'en' ? 'English' : '简体中文';
			},
			entres(){
				return (window.innerWidth > 768 ? false : true)&&this.user? false : true;
			}
		},
		methods: {
			changelink(){
				this.ulshow=false;
			},
			handleCommand(command) {
				if(command=='tourl'){
						window.open("https://app.classover.com/parent","_self")
				}
				else if(command=='logout'){
					this.logout() ;
				}
			},
			toshowul(){
				this.ulshow=!this.ulshow;
			},
			openover(){
				this.ulseen=!this.ulseen;
			},
			onMouseOver() {
			this.seen=true
			},
			onMouseOut() {
			this.seen=false
			},
			// gotologin(){
			// 	if(this.device)
			// 	this.logingo=false;
			// },
			langChange() {
				// if (command === this.lang) return;
				let command='en'
				if(this.lang=='en'){
					 command='zh_CN'
				}
				else{
					 command='en'
				}
				setStore(keys.lang, command);
				this.$i18n.locale = command;
				this.lang = command;
				this.$route.params.id=''
				location.reload();
			},
			logout() {
				clearStore();
				this.user = null;

				this.$intercom.shutdown()
				this.$intercom.hide()
				this.$router.push({ path: '/' });
				location.reload();

			},
			toUrl(url){
            	window.open(url,'_blank')
			},
			async updateIntercom () {
				await loadingData(async () => {
					try {
						let inter = await getIntercomUser(getTimeZoneCity())
						setStore(keys.IntercomUser, inter)
						let time_zone = this.utils.getTimeZoneCity()

						this.$intercom.update({
							user_id: getStore(keys.IntercomUser).userId,
							phone: getStore(keys.IntercomUser).phone,
							email: getStore(keys.IntercomUser).email,
							name: getStore(keys.IntercomUser).name,
							'Kid Name': getStore(keys.IntercomUser).kid_name,
							'Timezone': time_zone,
							'Paid user': getStore(keys.IntercomUser).paid_user,
							'Credit balance': getStore(keys.IntercomUser).credit_balance
						})
					} catch (error) {
						// this.status = false;
					}
				});
			},
		},
		// watch:{
		// 	user(){
		// 		this.logingo=true;
		// 	}
		// }
	};
</script>

<style lang="less" scoped >
.mobile-menu{
	 cursor:pointer;
	 img{
		 cursor:pointer;
	 }
}
  .el-dropdown-link{
	  display: flex;
	  align-items: center;
	  img{
		  cursor:pointer;
	  }
  }
   .change_lang{
	   img{
		   cursor:pointer;
		   margin-left: 5px;
	   }
	   img+img{
		   margin-right: 5px;
	   }
   }

   li{

	   position: relative;
	   .nav-header{
		   z-index: 99999999999999;
		   position: absolute;
		   width: 190px;
		   padding:  15px 10px;
		//    height: 100px;
		    border-radius: 25px;
		background: #FFFFFF;
		box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 14px 4px;
		   top: 40px;
		   left: -20px;
		   display: flex;
		//    justify-content:space-around;
		   div{
			   margin: 0  0px 0 20px;
			   display: flex;
			   flex-direction:column;
			   span{
				   line-height: 30px;
				   text-align: left;
				   font-size: 18px;
			   }
			   span:hover{
				       color: #ff6440;
			   }

		   }
	   }
   }
   .contenent{
	   display: flex;
	   align-items:center;
	    a{
		  display: flex;
	   align-items:center;

	   }

   }
	// pc
	@media screen and (min-width: @device) {
		.menucss{
			li{
				display: flex;
				align-items: center;
				font-family: 'Sofia Pro';
				font-style: normal;
				font-weight: 400;
				font-size: 15px;

				color: rgba(0, 0, 0, 0.85);
			}
			img{
				width: 18px;
				height: 19px;
				margin-right: 20px;
			}
		}
		.photopeople{
			display: flex;
			// display: none;
			img{
				width: 16px;
			}
		}
		.mobile-menu-nav{
			display: none;
		}
		.nav-list {
			display: flex;
			min-width: 550px;
			justify-content:center;
			li{
				margin: 0 15px;
			}
			.nav-header span, li,a{
				font-family: Sofia Pro,"Sarabun", Sans-serif;
				font-style: normal;
				font-weight: 400;
				// line-height: 1;
				font-size: 16px;
				color: #3B495E;
				display: flex;
				justify-items: center;
				align-items:center;

			}
			li i::before{
				margin-left: 10px;

			}

		}

		.login-register {
			display: flex;
		}

		.mobile-menu-dis {
			display: none;
		}
		.pccss{
			display: none;
		}
		.login-register-two{
			cursor: pointer;
			// position:relative;
			display: flex;
			align-items:center;
			// left: 40px;
			font-weight: 400;
			font-size: 11px;
			height: 29px;
			line-height: 20px;
			color: #000000;
			font-family: 'Sofia Pro';
			// height: 30px;
			background: #FFFFFF;
			border: 1px solid #F2F2F2;
			border-radius: 50px;
			padding: 5px 10px;
			margin-right: 10px;
			img{
				width: 27px;
				height: 27px;
			}
			.one{
				display: flex;
				align-items: center;
				text-align: center;
				height: 17px;
				margin-right: 4px;

			}
			.two{
				font-family: 'Sofia Pro SemiBold';
				// padding-top: 5px;
				font-weight: 500;
				font-size: 13px;
				color: #000000;
			}
		}
		.logout{
			display: flex;
			align-items:center;
		}
		.wp-nav{
			.logo{
				min-width: 230px;
			}
			.tool-btn{
				min-width: 230px;
			}

		}
	}
	.nav-list{
		a{
			text-decoration: none;
			// color:#000;
		}
	}
	.wp-nav {
		padding: 19px 0;
		display: flex;
		justify-content: space-between;
		max-width: 1280px;
		margin-left: auto;
		margin-right: auto;
		.logo {
			display: flex;
			flex-direction: column;
			justify-content: center;
			img {
				width: 168px;
				height: 47px;
			}
		}

		.nav-list {
			// display: flex;
			list-style: none;
			font-weight: 600;
			padding: 0;

			li {
				cursor: pointer;
			}

			// li + li {
			// 	margin-left: 20px;
			// }
		}
	}

	.tool-btn {
		vertical-align: middle;
		display: flex;
		line-height: 50px;
		// height: 45px;
		// flex-grow: 2;
		justify-content: space-evenly;
		align-items: center;
		.el-button {
			background-color: #4b69fe;
			color: white;
			border-radius: 20px;
		}
		.tbl > span {
			vertical-align: sub !important;
		}
	}

	.login-register {
		font-weight: 600;
		font-size: 14px;
		color: #4b69fe;
		margin-left: 16px;
		cursor: pointer;
		// display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.lang {
		// margin-left: 28px;
		cursor: pointer;
		display: flex;
		align-items: center;

		img {
			vertical-align: sub;
			width: 21px;
			height: 20px;
		}

		span {
			font-size: 10px;
			margin-left: 5px;
		}

		.lang-text {
			margin: 0 5px 0 10px;
		}
	}

	.main-container {
		display: flex;
		flex-direction: column;
		// max-width: 1076px;
		margin-left: auto;
		margin-right: auto;
	}

	.nav-btn {
		border: 1px solid #4b69fe;
		border-radius: 20px;
		height: 28px;
		min-width:91px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content:center;
		padding: 0 15px;
		cursor: pointer;
		margin-left: 24px;
		a{

			text-align: center;
		}
	}

	.background {
		background-color: #4b69fe;
		color: white;
	}
	.free-trial a{
		color: white;
		text-decoration: none;
		font-family: 'Sofia Pro SemiBold';
		font-style: normal;
		font-weight: 600;
		font-size: 14px;
	}

	// 移动端
	@media screen and (max-width: @device) {
		.nav-li{
			display: flex;
			align-items: center;

		}
		.mobile-menu-nav .nav-li a{
			color: #FFFFFF;
			font-family: 'Sofia Pro SemiBold';
			font-style: normal;
			font-weight: 600;
			font-size: 14px;
		}
		.nav-btn{
			width: 100%;
			margin:  0 20px;
			height: 32px;
		}
		.menucss{
			li{
				display: flex;
				align-items: center;
				font-family: 'Sofia Pro';
				font-style: normal;
				font-weight: 400;
				font-size: 14px;

				color: rgba(0, 0, 0, 0.85);
			}
			img{
				width: 13px;
				height: 13px;
				margin-right: 9px;
			}
		}
		.tool-btn {
			justify-content: flex-end;
			padding:0 15px;
			div{
			div+div{
				margin-left: 18px;
			}
			}


		}
		.main-container{
			width: 100vw;
			// overflow: hidden;
		}
		.nav-list {
			display: none;
		}
		 /deep/.el-dropdown{
			padding:0px;
			margin: 0px;
		}

		.login-register {

            .login-link{
						box-sizing: border-box;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						padding: 3px 10px;
						gap: 10px;
						width: 116px;
						height: 32px;
						background: #4B69FE;
						border: 0.5px solid #4B69FE;
						border-radius: 26px;
						flex: none;
						order: 0;
						flex-grow: 0;
              span{
				  width: auto;
                 height: 20px;
                  font-weight: 600;
                 font-size: 12px;
                 line-height: 20px;
                 display: flex;
                   align-items: center;
                 text-align: center;
                  font-feature-settings: 'salt' on;
                   color: #FFFFFF;
                   flex: none;
                   order: 1;
                   flex-grow: 0;
                     text-decoration:none;
			  }
			}
		}
		.login-register-two{
			// position:relative;
			cursor: pointer;
			display: flex;
			align-items:center;
			// margin-right: 10px;
			font-weight: 400;
			font-size: 11px;
			height: 23px;
			line-height: 20px;
			color: #000000;
			font-family: 'Sofia Pro';
			// height: 30px;
			background: #FFFFFF;
			border: 1px solid #F2F2F2;
			border-radius: 50px;
			padding: 5px 10px;
			img{
				width: 22px;
				height: 22px;
			}
			.one{
				text-align: center;
				height: 22px;
				margin-right: 4px;


			}
			.two{
				font-family: 'Sofia Pro';
				font-weight: 400;
				font-size: 11px;
				color: #000000;
			}
		}

		.free-trial {
			display: none !important;
		}

		.lang-text {
			display: none;
		}

		.mobile-menu {
			display: flex;
			// position: relative;
			// align-items: center;
			// margin-top: 10px;
			img {
				// width: 19.04px;
                // height: 18.5px;
				// margin: auto 16px auto 21px;
			}
		}
		.logout{
			img{
				width: 19.04px;
                height: 18.5px;
			}
		}

		.wp-nav {
			padding: 24px 0;
			.logo {
				margin: auto 0;
				margin-left: 16px;
				height: 33px;
				width: 110px;
				border-radius: 0px;
				img{
					height: 33px;
					width: 110px;
				}

			}
		}
		.lang{
			line-height: 40px;
			// padding-right: 22px;
			/deep/.el-dropdown{
			   margin: 0 ;
			}
		}
		.lang .nav-btn {
			display: flex;
			width: 50px;
			justify-content: space-between;
		}
		.phonecss{
			display: none;
		}
		.wp-nav{
			.phonecss{
			display: none;
		}
		}
		.mobile-menu-nav{
			z-index: 99999;
			position: absolute;
			width: 100%;
			top: 60px;
			list-style: none;
			padding: 0px 0 30px;
			background: #FFFFFF;
			li{
				margin: 0 18px;
				border-bottom:1px solid #c4c4c4;
				line-height: 64px;
				font-size: 16px;
				height: 64px;

			}
			li:nth-child(7){
				border: none;
			}
			li:nth-child(1){
				display: flex;
				justify-content:space-between;
				i{
					height: 20px;
					margin: 10px 20px;
				}
			}
			a {
			text-decoration: none;
			}

			.router-link-active {
			text-decoration: none;
			// color: #000;
			}
			.lisee{
			height: 130px;
		}
		}
		.ul-header{
			z-index: 9999999999;
			transform:translateZ(1px);
			display: flex;
			 position: absolute;
		   width:90vw;
			left: calc(5vw - 18px);
		   padding: auto;
		//    height: 100px;
		    border-radius: 30px;
		background: #FFFFFF;
		box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 14px 4px;
		   top: 50px;
		   display: flex;
		    flex-direction:column;
		   justify-content:space-around;
		   div{
			   margin: 10px 0px;
			   display: flex;
			   flex-direction:column;
			   span{
				   line-height: 30px;
				   padding-left: 20px;
				       color: #3B495E;
					       font-family: "Sarabun", Sans-serif;
						font-size: 18px;
						font-weight: 400;
			   }
			   span:hover{
				       color: #ff6440;
			   }

		   }
		}
		.photopeople{
			display: flex;
			img{
				width: 17px;
			}
		}
		.hamburger{
			align-items: center;

			img {
				// width: 17px;
                // height: 30px;
				// margin: auto 16px auto 21px;
				margin: 0;
			}
		}
	}

  .mobile-menu-nav{
	  li,a,li span,a span{
		  font-family: Sofia Pro, "Sarabun", Sans-serif;
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			color: #3B495E;
	  }
  }
	.nav-list .langcss,.langcss,.mobile-menu-nav .langcss {
	  font-weight: 600;
	  font-family: Sofia Pro SemiBold;
  }
  .menucss{
	background: #FFFFFF;
	box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
	border-radius: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue